import { Component } from '@angular/core';
import { CasesNotesService } from '../../_services/cases-notes.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CaseNote } from '../../_types/case-note';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LocalStorageService } from 'angular-web-storage';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { User } from 'src/app/modules/users/_types/user';
import { TasksService } from '../../../tasks/_services/tasks.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { Task } from 'src/app/modules/tasks/_types/task';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-note',
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.scss'],
    standalone: false
})
export class CasesDetailNoteComponent {
  public noteFormGroup!: RxFormGroup;

  public note: CaseNote = new CaseNote();
  public users: User[] = [];
  public selectedUser: string = "";
  public asociatedTask!: Task;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public generateTask: boolean = false;
  public processorId!: string ;

  constructor(
    private caseNotesService: CasesNotesService,
    private usersService: UsersService,
    private tasksService: TasksService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private storage: LocalStorageService,
    private loginService: LoginService
  ) {
    this.note.caseNoteType = "Internal";
    this.noteFormGroup = this.formBuilder.formGroup<CaseNote>(this.note) as RxFormGroup;
  }

  async ngOnInit() {
    this.processorId = this.config.data.processorId;
    let noteId = this.config.data.noteId;
    if (noteId) {
      await this.loadNote(noteId);
      // Ver si la nota tiene una tarea asociada
      let params: IParamsCollection = {};
      let filters: any = {
        caseNoteId: new Filter(FilterOperation.equals, "caseNoteId"),
      };
      filters.caseNoteId.value = noteId;
      params.filter = FilterBuilder.fromObject(filters).build();

      let response = await firstValueFrom(this.tasksService.all(params));

      if (response.data.length > 0) {
        this.asociatedTask = response.data[0];
      }
    } else {
      this.note.caseId = this.config.data.caseId;
      this.note.date = new Date();
    }
    this.loadUsers();
    this.allowWrite = this.loginService.hasPermission("CASES.WRITE") && this.loginService.hasPermission('CASES.WRITE_CASE_NOTE');
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE") && this.loginService.hasPermission('CASES.WRITE_CASE_NOTE');
  }

  async loadNote(noteId: string) {
    this.note = await firstValueFrom(this.caseNotesService.get(noteId));
    this.noteFormGroup.patchValue(this.note);
  }

  async loadUsers() {
    let filter:any = {
      isWorker: new Filter(FilterOperation.equals, "isWorker", '', false)
    };
    let params: IParamsCollection = {
      page: { number: 1, size: 1000 },
      sort: ["name"],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.usersService.all(params));
    this.users = response.data;
    this.selectedUser = this.processorId ?? null;
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.noteFormGroup);
    if (valid) {
      this.note = Object.assign(this.note, this.noteFormGroup.value);
      // processorId = userId conectado
      this.note.userId = this.storage.get("userId");

      let note = await firstValueFrom(this.caseNotesService.save(this.note));

      // Si tiene marcado generar tarea, se crea la tarea con la nota, caseId y userId
      if (this.generateTask) {
        let task = new Task();
        task.description = this.note.notes;
        task.caseNoteId = note.id || "";
        task.userId = this.selectedUser;
        task.date = this.note.date;
        await firstValueFrom(this.tasksService.save(task));
      }

      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Nota guardada correctamente." });
      this.dynamicDialogRef.close(this.note.id ? null : note.id);

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la nota  y la tarea asociada si tiene?",
      header: "Eliminar nota",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.caseNotesService.delete(this.note.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Nota eliminada correctamente." });
            this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  getUserName(userId: string) {
    let user = this.users.find(x => x.id == userId);
    return user ? user.name : "";
  }

  goToTask(task:Task){
    window.open(`/tasks/${task.id}`, "_blank");
    this.dynamicDialogRef.close();
  }

}
